import { expand } from 'uri-template-lite';
import { apiClient } from '../../../common/ApiClient';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';
import { SampleEditSessionUrl } from '../SampleEditSessionUrl';

interface UpdateSampleDraftsRequest {
  sessionId: string;
  rows: { rowId: number; payload: unknown }[];
}

const updateSampleDrafts = async ({
  sessionId,
  rows,
}: UpdateSampleDraftsRequest): Promise<void> => {
  await apiClient.patch(expand(SampleEditSessionUrl.rows, { sessionId }), {
    drafts: rows.map((row) => ({ ...row, op: 'UPDATE' })),
  });
};

export const useUpdateSampleDraftsMutation = createApiMutationHook<
  UpdateSampleDraftsRequest,
  void
>(['sample-drafts-update'], updateSampleDrafts);
